import type { DamageType } from "../damageType";
import type { ProjectileHittable } from "../interfaces";
import { PhysicalThingWithHp, STD_BASE_HP } from "../physicalThingWithHp";
import { Missile } from "../projectiles/missile";
import { deserializeXY } from "../serialization";
import type { Thing } from "../thing";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class MetalDoor extends PhysicalThingWithHp implements ProjectileHittable {
	static key = "MetalDoor";
	constructor(xy: XY) {
		super(xy, true);
		this.hp = STD_BASE_HP;
		this.maxHp = STD_BASE_HP;
	}

	getZOrder(): number {
		return ZOrder.SCENARIO;
	}

	applyDamage(type: DamageType | null, amount: number, source: Thing | null): number {
		if (source instanceof Missile) {
			return super.applyDamage(type, amount, source);
		}
		return 0;
	}

	onProjectileHit(_projectile: unknown): void {}

	isHittable(): boolean {
		return true;
	}

	static deserialize(data: any): MetalDoor {
		const d = new MetalDoor(deserializeXY(data.xy));
		d.restoreBaseFields(data);
		return d;
	}
}
